import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { all, call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';

import { httpGET, httpPUT } from '../../services/http.ts';
import { NotificationResponse, NotificationsMarkAsReadRequest } from '../../types/notification.ts';
import { notificationsReducer } from '../reducers/notifications.reducer.ts';

const { loadNotifications, setNotifications, markNotificationsRead, markNotificationsReadSuccess } =
  notificationsReducer.actions;

function* loadNotificationsAction() {
  try {
    const { data }: AxiosResponse<NotificationResponse[]> = yield call(httpGET, `/notifications`);
    yield put(setNotifications(data));
  } catch (error: unknown) {
    const errorMessage = `Failed to load notifications: ${error}`;
    console.error(errorMessage);
  }
}

function* markNotificationsReadAction(action: PayloadAction<number[] | undefined>) {
  try {
    // If no ids passed, mark all unread
    let ids = action.payload;
    if (!ids || ids.length === 0) {
      const items: NotificationResponse[] = yield select((state) => state.notifications.items);
      ids = items.filter((n) => !n.readAt).map((n) => n.id);
    }

    if (!ids || ids.length === 0) {
      yield put(markNotificationsReadSuccess([]));
      return;
    }

    const body: NotificationsMarkAsReadRequest = { ids };
    yield call(httpPUT, `/notifications/mark-as-read`, body);
    yield put(markNotificationsReadSuccess(ids));
  } catch (error: unknown) {
    const errorMessage = `Failed to mark notifications as read: ${error}`;
    console.log(errorMessage);
  }
}

export default function* notificationsSaga() {
  yield all([
    takeLatest(loadNotifications, loadNotificationsAction),
    takeEvery(markNotificationsRead, markNotificationsReadAction),
  ]);
}
